var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('sidebar'),_c('div',{attrs:{"id":"content-wrapper"}},[_c('div',{attrs:{"id":"content"}},[_c('topbar'),_c('router-view'),_c('bffooter')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }